import { render, staticRenderFns } from "./ParentEdit.vue?vue&type=template&id=790ae488"
import script from "../../../controllers/custom/parent/parent-edit.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/parent/parent-edit.js?vue&type=script&lang=js&external"
import style0 from "./ParentEdit.vue?vue&type=style&index=0&id=790ae488&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports